/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import Home from './Home';
import ServicesLayout from '../../components/ServicesLayout';

export default {

  path: '/',

  async action(ctx) {
    const state = await ctx.store.getState();
    return {
      component: <ServicesLayout active="main"><Home /></ServicesLayout>,
      description: "Inspire Hub - Platforma do publikacji danych przestrzennych dla gmin",
    }
  },
};



// WEBPACK FOOTER //
// src/routes/home/index.js